import { connect } from 'react-redux';

import Processing from '../../components/Processing/Processing';

const mapStateToProps = ({ processing }) => ({ isVisible: processing.counter > 0 })

export default connect(mapStateToProps)(Processing)
